import SkapaFormField, {
  type FormFieldAttributes as SkapaFormFieldAttributes,
  type FormFieldProps as SkapaFormFieldProps,
} from "@ingka/form-field";

export type FormFieldProps = SkapaFormFieldProps & SkapaFormFieldAttributes;

export const FormField = (props: FormFieldProps) => {
  return <SkapaFormField prefix="saleslead__" {...props} />;
};
